import { CtmAdModel } from '@mm/state/model/CtmAdModel';
import {
  isPromoter,
  PromoterConditionRuleOperatorCaptions,
  PromoterModel,
} from '@mm/state/model/PromoterModel';
import TriggerModel, { isTrigger } from '@mm/state/model/TriggerModel';

export const getCommentGuardSubtitle = (promoter: PromoterModel) => {
  if (
    (!promoter.postId || promoter.postId.toLocaleLowerCase() === 'all') &&
    !promoter.keywordsEnabled
  ) {
    return 'All Posts & All Comments';
  }
  if (
    !promoter.postId ||
    (promoter.postId.toLocaleLowerCase() === 'all' && promoter.keywordsEnabled)
  ) {
    return 'All Posts';
  }
  if (
    (promoter.postId || promoter.postId.toLocaleLowerCase() !== 'all') &&
    !promoter.keywordsEnabled
  ) {
    return 'All Comments';
  }
  return undefined;
};

export const getSubtitleByPromoter = (
  promoter: PromoterModel | TriggerModel,
) => {
  let keywordsSubtitle = '';

  if (isPromoter(promoter)) {
    keywordsSubtitle =
      promoter?.keywords && promoter.keywords.length > 2
        ? `${promoter.keywords.length - 2} more ${
            promoter.keywords.length - 2 === 1 ? 'keyword' : 'keywords'
          }`
        : '';
  }
  if (isTrigger(promoter)) {
    keywordsSubtitle =
      promoter?.phrases?.length > 2
        ? `${promoter.phrases.length - 2} more ${
            promoter.phrases.length - 2 === 1 ? 'keyword' : 'keywords'
          }`
        : '';
  }

  switch (promoter.kind) {
    case 'welcome_page':
      return 'Reply with a DM to followers who message your page';
    case 'instagram_welcomer':
      return 'Reply with a DM to followers who send you DM';
    case 'instagram_story_mention':
      return 'Reply with a DM to followers who mention you in their stories';
    case 'facebook_catch_all':
      return 'Reply with a DM when a user engages with you on Facebook';
    case 'instagram_catch_all':
      return 'Reply with a DM when a user engages with you on Instagram';
    case 'instagram_story_reaction':
      return promoter.keywordsEnabled ? keywordsSubtitle : 'All Reactions';
    case 'instagram_live_comment_guard':
      return promoter.keywordsEnabled ? keywordsSubtitle : 'All Live Comments';
    case 'instagram_comment_guard':
    case 'fb_comment_guard':
      return getCommentGuardSubtitle(promoter)
        ? getCommentGuardSubtitle(promoter)
        : keywordsSubtitle;
    case 'link':
    case 'instagram_link':
      return promoter.slugLink ? promoter.slugLink : promoter.tokenLink;
    case 'instagram_keywords':
    case 'facebook_keywords':
    case 'webchat_keywords':
    case 'sms_keywords':
      return keywordsSubtitle;
    default:
      '';
  }
};

export const getAdsSubtitle = (ad: CtmAdModel) => {
  if (ad?.adKind === 'synced_messenger_ad') {
    return ad.ad.adCampaignName
      ? `Campaign: ${ad.ad.adCampaignName}`
      : ad.ad.adCampaignId
      ? `Campaign ID: ${ad.ad.adCampaignId}`
      : ad.ad.adAccountId
      ? `Ad Account: ${ad.ad.adAccountId}`
      : 'Connected Manually';
  }
  if (ad?.adKind === 'new_messenger_ad') {
    return `Campaign: ${ad.ad.campaignName}`;
  }
};

export const getWebchatSubtitle = (promoter: PromoterModel) => {
  const rules = promoter?.conditions?.rules;
  const operator = promoter?.conditions?.rules?.[0]?.operator;
  const value = promoter.conditions?.rules?.[0]?.value;

  if (!rules) {
    return `Condition: is any page`;
  }

  if (rules && operator) {
    if (operator === '*') {
      return rules && rules.length === 1
        ? `Condition: ${PromoterConditionRuleOperatorCaptions[operator]}`
        : `${rules.length} conditions`;
    }

    return rules && rules.length === 1
      ? `Condition: URL ${PromoterConditionRuleOperatorCaptions[operator]} ${value}`
      : `${rules.length} conditions`;
  }
};

export const getAudiencesSubtitle = audiences => {
  const { length } = audiences;

  if (!length) {
    return 'Choose Audience';
  }
  if (length > 1) {
    return `${length - 1} more ${length - 1 === 1 ? 'audience' : 'audiences'}`;
  }
};
